<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="订单详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="6">订单号:</el-col>
        <el-col :span="6">
          <h1 class="order-no">
            {{ showForm.basic && showForm.basic.orderNo }}
          </h1>
        </el-col>
        <el-col :span="6">订单标题:</el-col>
        <el-col :span="6">
          <h1 class="order-no">{{ showForm.title }}</h1>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">订单金额:</el-col>
        <el-col :span="6">
          ¥{{ formatPrice(showForm.amount && showForm.amount.totalAmount) }}
        </el-col>
        <el-col :span="6">支付金额:</el-col>
        <el-col :span="6">
          ¥{{ formatPrice(showForm.amount && showForm.amount.payAmount) }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">提交时间:</el-col>
        <el-col :span="6">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
        <el-col :span="6">退款金额:</el-col>
        <el-col :span="6">
          ¥{{ formatPrice(showForm.amount && showForm.amount.refundAmount) }}
        </el-col>
      </el-row>
      <div
        class="main-task"
        v-if="showForm.basic && showForm.basic.dishList"
      >
        <el-row>
          <el-col :span="8">菜品名称</el-col>
          <el-col :span="4">菜品单价</el-col>
          <el-col :span="4">待核销数量</el-col>
          <el-col :span="4">已核销数量</el-col>
          <el-col :span="4">已退回数量</el-col>
        </el-row>
        <div
          v-for="(item, index) in showForm.basic.dishList"
          :key="index"
          class="single-product"
        >
          <el-row style="margin-top: 0px" v-if="item.title">
            <el-col :span="8">
              <h1 class="order-no">{{ item.title }}</h1>
              <p>{{item.spec&&item.makeOption?`${item.spec}/${item.makeOption}`:`${item.spec||''}${item.makeOption||''}`}}</p>
            </el-col>
            <el-col :span="4">
              <h1 class="order-no">¥{{ item.price }}</h1>
            </el-col>
            <el-col :span="4">
              <h1 class="order-no">{{ item.count }}</h1>
            </el-col>
            <el-col :span="4">
              <h1 class="order-no">{{ item.finishCount }}</h1>
            </el-col>
            <el-col :span="4">
              <h1 class="order-no">{{ item.rejectCount }}</h1>
            </el-col>
          </el-row>
        </div>
        <p>共{{ showForm.basic.dishList.length }}种商品</p>
      </div>
      <el-row>
        <el-col :span="6">房间号:</el-col>
        <el-col :span="18">
          {{ showForm.room && showForm.room.title }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">房间密码:</el-col>
        <el-col :span="18">
          {{ showForm.basic && showForm.basic.password || '生成密码中' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">预约时间:</el-col>
        <el-col :span="18">
          {{ showForm.basic && showForm.basic.reserveDate }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">预约时段:</el-col>
        <el-col :span="18">
          <span v-for="(item,index) of showForm.basic.sectionList" :key="index">{{item.title}}({{item.startTime}}-{{item.endTime}})</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">预约服务:</el-col>
        <el-col :span="18">
          <span v-for="(item,index) of showForm.basic.serviceList" :key="index">{{item.title}}({{item.count}})</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">备注:</el-col>
        <el-col :span="18">
          {{ (showForm.basic && showForm.basic.text) || '无' }}
        </el-col>
      </el-row>
      <el-row style="margin-top: 5px">
        <el-col :span="6">支付方式:</el-col>
        <el-col :span="18">
          <p>{{ formatChannel(showForm) }}</p>
          <p v-if="formatBank(showForm)">
            银行类型：{{ formatBank(showForm) }}
          </p>
          <p v-if="showForm.payment.orderNo">
            交易单号：{{ showForm.payment.orderNo }}
          </p>
        </el-col>
      </el-row>
      <el-row style="margin-top: 5px">
        <el-col :span="6">订单状态:</el-col>
        <el-col :span="6">
          <el-tag type="primary" v-if="showForm.step == 1">待付款</el-tag>
          <el-tag type="success" v-if="showForm.step == 2">已付款</el-tag>
          <el-tag type="warning" v-if="showForm.step == 3">已发货</el-tag>
          <el-tag type="warning" v-if="showForm.step == 4">已核销</el-tag>
          <el-tag type="danger" v-if="showForm.step == 5">已退款</el-tag>
          <el-tag type="info" v-if="showForm.step == 6">已取消</el-tag>
          <el-tag type="warning" v-if="showForm.step == 8">退款中</el-tag>
        </el-col>
        <template v-if="showForm.step == 4">
          <el-col :span="6">核销时间:</el-col>
          <el-col :span="6">
            {{
              moment(showForm.extra && showForm.extra.finishTime).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            }}
          </el-col>
        </template>
      </el-row>
      <el-row
        style="margin-top: 5px"
        v-if="showForm.basic && showForm.basic.contact"
      >
        <el-col :span="6">联系方式:</el-col>
        <el-col :span="18">
          <p>
            姓名：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.name) ||
              '未填写'
            }}
          </p>
          <p>
            手机号：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.tel) ||
              '未填写'
            }}
          </p>
          <p>
            收货地址：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.receiveProvince + showForm.basic.contact.receiveCity + showForm.basic.contact.receiveDistrict + showForm.basic.contact.receiveAddress) ||
              '未填写'
            }}
          </p>
        </el-col>
      </el-row>
      <template #footer>
        <!-- <el-button
          type="primary"
          v-if="checkVerify()"
          @click="verifyVisible = true"
          style="float: left"
        >
          核销
        </el-button> -->
        <el-button
          v-if="checkRefund()"
          style="float: left"
          type="warning"
          @click="handleRefund"
        >
          退款
        </el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
    <el-dialog title="订单核销" v-model="verifyVisible" width="60%">
      <div v-if="productList.length">
        <el-table :data="productList">
          <el-table-column label="菜品名称" prop="title" />
          <el-table-column label="待核销数量" prop="count" />
          <el-table-column label="已核销数量" prop="finishCount" />
          <el-table-column label="已退回数量" prop="rejectCount" />
          <el-table-column label="本次核销数量">
            <template #default="{ row }">
              <el-input-number
                v-model="row.verifyCount"
                :min="0"
                :max="
                  row.count - row.finishCount > 0
                    ? row.count - row.finishCount
                    : 0
                "
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <el-button @click="verifyVisible = false">取 消</el-button>
        <el-button :loading="verifyLoading" type="primary" @click="verifyOrder">
          确 定
        </el-button>
      </template>
    </el-dialog>
    <product-refund ref="productRefund"></product-refund>
  </div>
</template>

<script>
import moment from 'moment'
import lodash from 'lodash'
import {
  findOrder,
  // finishOrder,
  refundOrder,
} from '@/api/chess'
import { orderChannels } from '@/utils/const'
import {
  filterPrice,
  checkOrderVerify,
  checkOrderRefund,
  checkRefundAmount,
} from '@/utils/tool'
import { bank } from '@/utils/bank'
import ProductRefund from './refund.vue'
export default {
  name: 'ChessOrderDetail',
  components: { ProductRefund },
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      bank,
      showForm: {},
      productList: [],
      refundList: [],
      dialogFormVisible: false,
      verifyVisible: false,
      verifyLoading: false,

      shipVisible: false,
      shipLoading: false,
      shipmentForm: {
        orderId: '',
        companyName: '',
        shipOrderNo: '',
        shipTime: '',
      },
      refundVisible: false,
      refundLoading: false,
      refundAmount: 0,
    }
  },
  methods: {
    // 格式化订单支付方式
    formatChannel(row) {
      const channel = (row && row.payment && row.payment.channel) || 'UNKOWN'
      return orderChannels[channel]
    },
    // 格式化金额
    formatPrice(price) {
      return filterPrice(price)
    },
    formatBank(form) {
      const type = form && form.payment && form.payment.bankType || ''
      return bank[type] || ''
    },
    // 检查是否能核销
    checkVerify() {
      return checkOrderVerify(this.showForm)
    },
    // 检查是否能退款
    checkRefund() {
      return checkOrderRefund(this.showForm)
    },
    // 获取能退的金额
    getRefundAmount() {
      return checkRefundAmount(this.showForm)
    },
    // 核销订单
    async verifyOrder() {
      this.verifyLoading = true
      const list = []
      this.productList
        .filter((i) => !!i.verifyCount)
        .forEach((i) => {
          list.push({
            dishId: i.dishId,
            count: i.verifyCount,
          })
        })
      const result = await finishOrder({
        orderId: this.showForm.orderId,
        dishList: list,
      })
      this.verifyLoading = false
      if (!!result) {
        this.verifyVisible = false
        this.dialogFormVisible = false
        this.$message.success('核销成功')
        this.$emit('fetch-data')
      }
    },
    // 订单退款
    handleRefund() {
      this.$refs.productRefund.showRefund(this.showForm)
    },
    async show(row) {
      const data = await findOrder({
        orderId: row.orderId,
      })
      this.showForm = data
      this.productList =
        lodash.cloneDeep(data.basic && data.basic.dishList) || []
      this.refundList =
        lodash.cloneDeep(data.basic && data.basic.dishList) || []
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-width {
  width: 220px;
}

.order-no {
  font-size: 18px;
  margin: 0;
}

.main-task {
  border: 2px dashed #f56c6c;
  box-sizing: border-box;
  padding: 10px;
  margin: 10px 0;
  overflow: hidden;
}

.single-product {
  border-bottom: 1px dashed #333333;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.el-row {
  padding: 10px 0;
}

.express_item {
  & + .express_item {
    margin-top: 10px;
  }

  span {
    font-weight: 600;
  }
}
</style>
